export default "__VITE_ASSET__CyEdBVIl__"